'use es6';

import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { quitOnboardingTour, finishTourInPage } from 'ContentEditorUI/redux/actions/onboardingTourStateActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuitLPTourModal = ({
  onCancel,
  onboardingTourIframe
}) => {
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  const quitTour = () => {
    dispatch(quitOnboardingTour());
    if (onboardingTourIframe === 'inpage') {
      dispatch(finishTourInPage());
    } else {
      tour.finish();
    }
    onCancel();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 500,
    children: [/*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("h4", {
        style: {
          fontWeight: 'bold'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "freeLPTour.quitModal.header"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "freeLPTour.quitModal.body"
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: quitTour,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "freeLPTour.quitModal.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "freeLPTour.quitModal.cancel"
        })
      })]
    })]
  });
};
QuitLPTourModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onboardingTourIframe: PropTypes.string.isRequired
};
export default QuitLPTourModal;